'use client'

import { useRouter } from '@/navigation'
import { Loader2 } from 'lucide-react'
import { useRouter as useNextRouter, useSearchParams } from 'next/navigation'

import { trpc } from '../../_trpc/client'

export const dynamic = 'force-dynamic'

const Page = ({ params }) => {
  const { locale } = params
  const router = useRouter()
  const nextRouter = useNextRouter()

  const searchParams = useSearchParams()
  const origin = searchParams.get('origin')

  trpc.authCallback.useQuery(undefined, {
    onSuccess: ({ success, unauthorized }) => {
      if (unauthorized) {
        nextRouter.push(`/sign-in`)
      }
      if (success) {
        // user is synced to db
        router.push(origin ? `/${origin}` : `/courtrulings`)
      }
    },
    onError: (err) => {
      console.error(err)
      if (err.data?.code === 'UNAUTHORIZED') {
        nextRouter.push(`/sign-in`)
      }
    },
    retry: true,
    retryDelay: 1000,
  })

  return (
    <div className="mt-24 flex w-full justify-center">
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-zinc-800" />
        <h3 className="text-xl font-semibold">Setting up your account...</h3>
        <p>You will be redirected automatically.</p>
      </div>
    </div>
  )
}

export default Page
